import { render } from "./Product.vue?vue&type=template&id=22ea72f0&scoped=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=22ea72f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22ea72f0"

export default script